import React, { useCallback, useEffect, useMemo } from 'react';
import {
    Route, Routes, useNavigate, useParams,
} from 'react-router-dom';
import { useClientLayout } from 'pages/ClientOverview/hooks/useClientLayout';
import RouteBasedStepperLayout from 'prodivers/RouteBasedStepperLayout';
import { flattenSteps } from 'utils/stepDefintion';
import { ChangeWithdrawalProvider } from 'datasource/ChangeWithdrawal/ChangeWithdrawalManager';
import { useManagerProfile } from 'prodivers/managerProfile';
import { accessPolicies } from 'prodivers/managerProfile/constants';
import { useTranslation } from 'react-i18next';
import { useClientProfile } from 'prodivers/clientProfile';
import { StepControllerProvider } from 'components/Stepper/RouteBasedStepper/StepControllerContext';
import useChangeWithdrawalFlow from './hooks/useChangeWithdrawalFlow';
import { useChangeWithdrawalPlanLayout } from './hooks/useChangeWithdrawalPlanLayout';

const Router = () => {
    const { dfsClientId } = useParams();
    const navigate = useNavigate();
    const { t, i18n: { language } } = useTranslation();
    const {
        clientName,
    } = useClientProfile();
    const {
        hasAccessPolicy, isPolicyLoading, isLoading,
    } = useManagerProfile();
    const { stepsBasedOnState } = useChangeWithdrawalFlow();
    const changeWithdrawalSteps = useMemo(() => flattenSteps(stepsBasedOnState), [stepsBasedOnState]);

    const headerNavLeftButtonOnLeftButtonClick = useCallback(
        () => { navigate(`/client/${dfsClientId}/`); },
        [dfsClientId],
    );

    const headerNavLeftButton = useMemo(
        () => ({ type: 'login', label: `${t('clientDashboard.backTo')} ${clientName}` }),
        [clientName, language],
    );

    useClientLayout(
        false,
        false,
        headerNavLeftButton,
        headerNavLeftButtonOnLeftButtonClick,
    );

    useEffect(() => {
        if (!isLoading && !isPolicyLoading && (!hasAccessPolicy(accessPolicies?.EnableZIVVWithdrawalPlanChange) && !hasAccessPolicy(accessPolicies?.EnableZIFDWithdrawalPlanChange))) {
            headerNavLeftButtonOnLeftButtonClick();
        }
    }, [hasAccessPolicy, isLoading, isPolicyLoading, headerNavLeftButtonOnLeftButtonClick]);

    return (
        <StepControllerProvider>
            <ChangeWithdrawalProvider>
                <RouteBasedStepperLayout dataSource={useChangeWithdrawalPlanLayout}>
                    <Routes>
                        {Object.keys(changeWithdrawalSteps).map((key) => {
                            const route = changeWithdrawalSteps[key];
                            const Component = route.component;

                            return (
                                <Route
                                    path={route.url}
                                    key={key}
                                    element={<Component {...{ datasource: route.datasource }}/>}
                                />
                            );
                        })}
                    </Routes>
                </RouteBasedStepperLayout>
            </ChangeWithdrawalProvider>
        </StepControllerProvider>
    );
};

Router.displayName = 'Router';

export default Router;
